import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { rem, ellipsis } from 'polished';
import TitleWidget from '../../core/TitleWidget';
import BoxInside from '../../core/BoxInside';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../../core/Icon';

const StyledBoxInside = styled(BoxInside)`
  padding-bottom: ${rem('80px')};
`;

const StyledTitleWidget = styled(TitleWidget)`
  line-height: ${rem('30px')};
  margin-bottom: ${rem('25px')};
  margin-left: ${rem('19px')};
  padding-left: ${rem('43px')};

  & > svg {
    left: ${rem('-17px')};
    top: ${rem('-3px')};
    bottom: inherit;

    bottom: 0;
    ${mediaqueries.greaterThan('desktop')`
      left: ${rem('-18px')};
      width: ${rem('48px')};
      height: ${rem('48px')};
      top: ${rem('-12px')};
    `};
  }
`;

const StyledDocuments = styled.div`
  width: 100%;
`;

const StyledDocumentsTitle = styled.h2`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('16px')};
  color: ${props => props.theme.colors.grayDarkest};
  margin-bottom: ${rem('5px')};
`;

const StyledDocumentsList = styled.ul`
  border-top: ${rem('2px')} solid ${props => props.theme.colors.dark};
  border-left: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  border-right: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  padding: 0;
  margin: ${rem('3px')} 0 0 0;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: ${rem('1px')};
    background-color: ${props => props.theme.colors.grayLighter};
  }
`;

const StyledDocumentsItem = styled.li`
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  padding: 0 ${rem('10px')} 0;
  width: 100%;
  display: flex;
  align-items: center;
  &:before {
    display: none;
  }
  ${mediaqueries.greaterThan('mobile')`
    width: 50%;
  `};
  ${mediaqueries.greaterThan('desktop')`
    width: 33.3%;
  `};
`;

const StyledDocumentsDownload = styled(Link)`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${rem('8px')} 0;
  cursor: pointer;
`;

const IconDocuments = styled(Icon)`
  min-width: ${rem('36px')};
  max-width: ${rem('36px')};
  height: ${rem('27px')};
  margin-right: ${rem('10px')};
  flex-grow: 2;
`;

const StyledDocumentsName = styled.span`
  font-family: ${props => props.theme.fonts.book};
  font-size: ${rem('14px')};
  color: ${props => props.theme.colors.grayDark};
  width: ${ellipsis('98%')};
`;

const StyledCenter = styled.div`
  width: ${rem('80px')};
  margin: ${rem('10px')} auto 0;
`;

export {
  StyledBoxInside,
  StyledTitleWidget,
  StyledDocuments,
  StyledDocumentsTitle,
  StyledDocumentsList,
  StyledDocumentsItem,
  StyledDocumentsDownload,
  IconDocuments,
  StyledDocumentsName,
  StyledCenter
};
